import * as z from "zod/v4";
import { UlidSchema } from "./ulid.ts";
import { IsoDateTimeSchema } from "./iso.ts";
import { ResultSchemaOf } from "./result.ts";
import { nowIsoString } from "../util/date.ts";
import { MAX_FILE_SIZE_BYTES, MimeTypeSchema } from "./mime-type.ts";
import { Sha256Schema } from "./sha256.ts";

// Project attachment schema
export const AttachmentSchema = z.object({
  id: UlidSchema,
  sha256: Sha256Schema,
  filename: z.string().min(1).describe("Original filename"),
  mime_type: MimeTypeSchema,
  size_bytes: z.number().int().positive().max(MAX_FILE_SIZE_BYTES),
  project_id: UlidSchema,
  created_at: IsoDateTimeSchema.default(nowIsoString),
});

export type Attachment = z.infer<typeof AttachmentSchema>;

export const AttachmentArraySchema = z.array(AttachmentSchema);
export type AttachmentArray = z.infer<typeof AttachmentArraySchema>;

// Attachment with signed URL for download
export const AttachmentWithUrlSchema = AttachmentSchema.extend({
  signed_url: z.url().describe("Signed URL for downloading the attachment"),
});

export type AttachmentWithUrl = z.infer<typeof AttachmentWithUrlSchema>;

// Result types
export const AttachmentResultSchema = ResultSchemaOf(
  AttachmentSchema,
  z.string(),
);
export type AttachmentResult = z.infer<typeof AttachmentResultSchema>;

export const AttachmentArrayResultSchema = ResultSchemaOf(
  AttachmentArraySchema,
  z.string(),
);
export type AttachmentArrayResult = z.infer<typeof AttachmentArrayResultSchema>;

export const AttachmentWithUrlResultSchema = ResultSchemaOf(
  AttachmentWithUrlSchema,
  z.string(),
);
export type AttachmentWithUrlResult = z.infer<
  typeof AttachmentWithUrlResultSchema
>;
